// project imports
import { handlerCategoryDialog } from '@api/_categories';
import { handlerSubCategoryDialog } from '@api/_sub-categories';
import { handlerLabDialog } from '@api/_labs';
import { NavActionType } from '../config';

// assets
import BuildOutlined from '@ant-design/icons/BuildOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import CustomerServiceOutlined from '@ant-design/icons/CustomerServiceOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';
import ShoppingCartOutlined from '@ant-design/icons/ShoppingCartOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import AppstoreAddOutlined from '@ant-design/icons/AppstoreAddOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import LinkOutlined from '@ant-design/icons/LinkOutlined';
import FormOutlined from '@ant-design/icons/FormOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';
import { Role } from 'src/types';
import { AppstoreOutlined } from '@ant-design/icons';
{
  /* <FormOutlined /> */
}
// icons
const icons = {
  AppstoreOutlined,
  BuildOutlined,
  CalendarOutlined,
  CustomerServiceOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  AppstoreAddOutlined,
  FileTextOutlined,
  PlusOutlined,
  LinkOutlined,
  FormOutlined,
  BarChartOutlined
};

// ==============================|| MENU ITEMS - LABADMIN ||============================== //

const labAdminPages = {
  id: 'group-configurator',
  title: '',
  icon: icons.AppstoreAddOutlined,
  type: 'group',
  roles: [Role.LabAdmin, Role.User],
  children: [
    {
      id: 'reports',
      title: 'reports',
      type: 'item',
      url: '/reports',
      icon: icons.BarChartOutlined,
      roles: [Role.User, Role.LabAdmin]
    },
    // {
    //   id: 'pricing',
    //   title: 'pricing',
    //   type: 'item',
    //   url: '/pricing',
    //   icon: icons.FormOutlined,
    //   roles: [Role.User, Role.LabAdmin]
    // },
    {
      id: 'plans',
      title: 'plans',
      type: 'item',
      url: '/plans',
      icon: icons.FormOutlined,
      roles: [Role.User, Role.LabAdmin]
    },
    {
      id: 'usage',
      title: 'usage',
      type: 'item',
      url: '/rate-limits',
      icon: icons.BarChartOutlined,
      roles: [Role.User, Role.LabAdmin]
    }
  ]
};

export default labAdminPages;
